module.exports = __webpack_public_path__ + "assets/close-blue-4d376b.svg";